import { render, staticRenderFns } from "./nav-top.vue?vue&type=template&id=e5bf3114&scoped=true"
import script from "./nav-top.vue?vue&type=script&lang=js"
export * from "./nav-top.vue?vue&type=script&lang=js"
import style0 from "./nav-top.vue?vue&type=style&index=0&id=e5bf3114&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5bf3114",
  null
  
)

export default component.exports